import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import {
  ManageDocketTemplateFilterRootParamList,
  ManageDocketTemplateRootParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { ManageDocketTemplateFilterScreen } from "../ManageDocketTemplateFilterScreen/ManageDocketTemplateFilterScreen";
import { ManageDocketTemplateFilterRootContext } from "./context";
import { DocketTemplateFilterSelectTypeScreen } from "../DocketTemplateFilterSelectTypeScreen/DocketTemplateFilterSelectTypeScreen";
import {
  FormProvider,
  useForm,
  useFormContext,
  UseFormReturn,
} from "react-hook-form";
import {
  DocketFilterFormValues,
  DocketTemplateFormValues,
} from "../../components/DocketTemplateForm/types";
import { createContext } from "react";
import { DocketFilterType } from "@towersystems/roam-common/lib/generated-types";
import { DepartmentListScreen } from "../../../../components/DepartmentListScreen";
import { DepartmentListScreenContext } from "../../../../components/DepartmentListScreen/context";
import { CategoryListScreen } from "../../../../components/CategoryListScreen";
import { CategoryListScreenContext } from "../../../../components/CategoryListScreen/context";

const Stack =
  createStackHeaderNavigator<ManageDocketTemplateFilterRootParamList>();

export interface ManageDocketTemplateFilterRootScreenProps
  extends StackScreenProps<
    ManageDocketTemplateRootParamList,
    "ManageDocketTemplateFilterRootScreen"
  > {}

// must create own context otherwise it will use the useFormContext from the parent
export const InnerFormContext = createContext<
  UseFormReturn<DocketFilterFormValues> | undefined
>(undefined);

export const ManageDocketTemplateFilterRootScreen = ({
  navigation,
  route,
}: ManageDocketTemplateFilterRootScreenProps) => {
  const index = route?.params?.index;
  const { watch } = useFormContext<DocketTemplateFormValues>();

  const watchedFilters = watch("filters");
  const isExistingFilter = index !== undefined;
  const watchedFilter = isExistingFilter ? watchedFilters[index] : undefined;

  const methods = useForm<DocketFilterFormValues>({
    defaultValues: watchedFilter ?? {
      type: DocketFilterType.TAG,
      values: [],
    },
  });

  return (
    <DepartmentListScreenContext.Provider
      value={{
        onSelect(department) {
          const c = methods.getValues("values");
          methods.setValue("values", [...c, { value: department.id }]);
        },
      }}
    >
      <CategoryListScreenContext.Provider
        value={{
          onSelect(category) {
            const c = methods.getValues("values");
            methods.setValue("values", [...c, { value: category.id }]);
          },
        }}
      >
        <InnerFormContext.Provider value={{ ...methods }}>
          <ManageDocketTemplateFilterRootContext.Provider value={{ index }}>
            <Stack.Navigator
              screenOptions={{
                animationEnabled: true,
                title: "",
              }}
            >
              <Stack.Group
                screenOptions={{
                  headerShown: true,
                  headerLeft: () => <ModalCloseButton type="Close" />,

                  cardStyleInterpolator:
                    CardStyleInterpolators.forHorizontalIOS,
                }}
              >
                <Stack.Screen
                  name="ManageDocketTemplateFilterScreen"
                  component={ManageDocketTemplateFilterScreen}
                />
              </Stack.Group>
              <Stack.Group
                screenOptions={{
                  headerShown: true,
                  headerLeft: () => <ModalCloseButton type="Back" />,
                  cardStyleInterpolator:
                    CardStyleInterpolators.forHorizontalIOS,
                }}
              >
                <Stack.Screen
                  name="DocketTemplateFilterSelectTypeScreen"
                  component={DocketTemplateFilterSelectTypeScreen}
                />
                <Stack.Screen
                  name="DepartmentListScreen"
                  component={DepartmentListScreen}
                />
                <Stack.Screen
                  name="CategoryListScreen"
                  component={CategoryListScreen}
                />
              </Stack.Group>
            </Stack.Navigator>
          </ManageDocketTemplateFilterRootContext.Provider>
        </InnerFormContext.Provider>
      </CategoryListScreenContext.Provider>
    </DepartmentListScreenContext.Provider>
  );
};
